<template>
  <section class="order-header">
    <ul>
      <li>
        <span class="name">道路名称</span>
        <span class="value">{{ detail.parkingName ||'无'}}</span>
      </li>
      <li>
        <span class="name">车位编号</span>
        <span class="value">{{ detail.spaceNum||'无' }}</span>
      </li>
      <li>
        <span class="name">车牌号</span>
        <span class="value">{{ detail.carNumber||'无' }}</span>
      </li>
      <li>
        <span class="name">车牌类型</span>
        <span class="value">{{ detail.carType||'无' }}</span>
      </li>
      <li>
        <span class="name">手机号</span>
        <span class="value">{{ detail.phone ||'无'}}</span>
      </li>
      <li>
        <span class="name">旧系统数据备注</span>
        <span class="value">{{ detail.attr6 ||'无'}}</span>
      </li>
    </ul>
  </section>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
    },
  },
  data() {
    return {

    };
  },
  watch: {
   
  },
  mounted() {
    
  },
  activated() {

  },
  methods: {},
};
</script>
<style scoped>
.order-header {
  padding: 20px 0;
  box-sizing: border-box;
}
ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
ul li {
  margin-right: 20px;
}
ul li .name {
  margin-right: 10px;
  font-weight: bold;
}
ul li .value {
  color: #2a9df5;
  font-weight: bold;
}
</style>
